import React, { ReactElement } from 'react';

import { TextLarge, TextRegular } from '../../components/Text';
import TInputLabel from './TInputLabel';

const InputLabel = ({ htmlFor, isInputRequired, labelText, optionalText }: TInputLabel): ReactElement => (
  <>
    <TextLarge as="label" color="text-secondary" htmlFor={htmlFor}>
      {labelText}
      {!isInputRequired && optionalText && (
        <TextRegular as="span" color="text-secondary" utilities={['marginLeftXxxs']}>
          {`(${optionalText})`}
        </TextRegular>
      )}
    </TextLarge>
  </>
);

export default InputLabel;
